// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__V8Lu+","logo":"Footer_logo__etHhq"};